/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Custom_SectionsInputs */

const en_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Sections`)
};

const de_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Abschnitte`)
};

const fr_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections personnalisees`)
};

const es_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secciones personalizadas`)
};

const it_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sezioni personalizzate`)
};

const nl_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangepaste secties`)
};

const pl_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekcje niestandardowe`)
};

const fi_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mukautetut osiot`)
};

const da_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpassede sektioner`)
};

const sv_resume_editor_custom_sections = /** @type {(inputs: Resume_Editor_Custom_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassade sektioner`)
};

/**
* | output |
* | --- |
* | "Custom Sections" |
*
* @param {Resume_Editor_Custom_SectionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_custom_sections = /** @type {((inputs?: Resume_Editor_Custom_SectionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Custom_SectionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_custom_sections(inputs)
	if (locale === "fr") return fr_resume_editor_custom_sections(inputs)
	if (locale === "es") return es_resume_editor_custom_sections(inputs)
	if (locale === "it") return it_resume_editor_custom_sections(inputs)
	if (locale === "nl") return nl_resume_editor_custom_sections(inputs)
	if (locale === "pl") return pl_resume_editor_custom_sections(inputs)
	if (locale === "fi") return fi_resume_editor_custom_sections(inputs)
	if (locale === "da") return da_resume_editor_custom_sections(inputs)
	if (locale === "sv") return sv_resume_editor_custom_sections(inputs)
	return en_resume_editor_custom_sections(inputs)
});